<template>
  <div style="padding: 20px">
    <div style="padding-bottom: 20px">
      <select-area @areaListId="getAreaListId"/>
      <el-date-picker
          v-model="query.yearAndMonth"
          type="month"
          style="width: 160px;margin-right: 10px"
          value-format="YYYY-MM"
          placeholder="年月选择">
      </el-date-picker>
      <el-input v-model="query.info" placeholder="姓名" style="width: 160px;margin-right: 10px"></el-input>
      <el-button type="primary" @click="selectTableData()">搜索</el-button>
      <el-button type="primary" @click="detailDialog=true">新增</el-button>

      <el-button type="primary" @click="courseFeeImportDialog=true">批量导入</el-button>
      <el-popconfirm @confirm="exportCoachClassFee" title="确定要导出吗？">
        <template #reference>
          <el-button type="primary" icon="Download">导出</el-button>
        </template>
      </el-popconfirm>
    </div>
    <!--    列表-->
    <el-table
        v-loading="tableLoading"
        :data="tableData"
        border
        :row-style="{ height: '20px' }"
        :cell-style="{ padding: '16px' }"
        class="table"
        ref="multipleTable"
        header-cell-class-name="table-header">
      <el-table-column prop="coachName" label="姓名" width="160"></el-table-column>
      <el-table-column prop="areaName" label="校区" width="310"></el-table-column>
      <el-table-column prop="coachType" label="类型" width="110"></el-table-column>
      <el-table-column prop="coachGrade" label="级别" width="110"></el-table-column>
      <el-table-column label="课时费">
        <el-table-column prop="classMoney" label="大课" width="110"></el-table-column>
        <el-table-column prop="oneHourMoney" label="1小时" width="110"></el-table-column>
        <el-table-column prop="oneHalfHourMoney" label="1.5小时" width="110"></el-table-column>
        <el-table-column prop="twoHourMoney" label="2小时" width="110"></el-table-column>
      </el-table-column>
      <el-table-column prop="applyDate" label="开始执行月份" width="210" show-overflow-tooltip>
        <template #default="scope">{{ scope.row.year }}年{{ scope.row.month }}月
        </template>
      </el-table-column>
      <el-table-column prop="updateCoachName" label="更新人" width="140" show-overflow-tooltip></el-table-column>
      <el-table-column prop="updateTime" label="更新时间" width="210" show-overflow-tooltip></el-table-column>
      <el-table-column label="详情" width="100" fixed="right" align="center">
        <template #default="scope">
          <el-button @click="detailDialog=true,detailModify = scope.row,initModifyData()" size="small"
                     style="padding: 0;margin: 0"
                     type="text">编辑
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <!--    分页组件-->
    <div class="pagination">
      <el-pagination
          background
          layout="total, prev, pager, next"
          :current-page="query.pageIndex"
          :page-size="query.pageSize"
          :total="query.pageTotal"
          @current-change="handlePageChange"
      ></el-pagination>
    </div>
    <!--    新增/修改 弹框-->
    <el-dialog
        title="新增/修改 课时费"
        draggable
        v-model="detailDialog"
        width="500px">
      <el-form :model="detail" :rules="formRules" ref="formRuleRef" label-width="120px" class="mt-4">
        <el-form-item label="执行月份" prop="applyDate">
          <el-date-picker
              v-model="detail.applyDate" :disabled="detail.onModify"
              type="month"
              format="YYYY/MM"
              value-format="YYYY-MM"
              placeholder="请选择执行月份"
              @click.stop
              @calendar-change.stop style="width: 260px;margin-right: 10px"/>
        </el-form-item>
        <el-form-item label="教练" prop="coachId">
          <el-select v-model="detail.coachId" placeholder="请选择教练" :disabled="detail.onModify"
                     clearable
                     filterable="true" remote="true" style="width: 260px;margin-right: 10px"
                     :remote-method="fetchCoachList"
          >
            <el-option
                v-for="tCoach in coachList"
                :key="tCoach.coachid"
                :label="tCoach.coachname"
                :value="tCoach.coachid"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="大课课时费" prop="classMoney">
          <el-input-number v-model="detail.classMoney" style="width: 260px;margin-right: 10px"></el-input-number>
        </el-form-item>

        <el-form-item label="小时课时费">
          <el-input-number v-model="detail.oneHourMoney" style="width: 260px;margin-right: 10px"></el-input-number>
        </el-form-item>

        <el-form-item label="1.5小时课时费">
          <el-input-number v-model="detail.oneHalfHourMoney" style="width: 260px;margin-right: 10px"></el-input-number>
        </el-form-item>
        <el-form-item label="2小时课时费">
          <el-input-number v-model="detail.twoHourMoney" style="width: 260px;margin-right: 10px"></el-input-number>
        </el-form-item>

        <el-form-item label="课时费级别">
          <el-input v-model="detail.coachGrade" placeholder="请输入 实习/初级/中级/高级"
                    style="width: 260px;margin-right: 10px"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleSubmit">保存</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <!--导入 弹框-->
    <el-dialog
        v-model="courseFeeImportDialog"
        width="366px"
        :append-to-body="true"
        :draggable="true"
        title="批量导入课时费等级调整"
    >
      <el-form-item title="年月选择">
        <el-date-picker
            v-model="importFeeYearMonth"
            type="month"
            style="width: 270px;"
            value-format="YYYY-MM"
            placeholder="年月选择">
        </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-upload
            drag
            :limit="limitFileNum"
            :auto-upload="false"
            :on-change="fileChange"
            :on-exceed="exceedFile"
            :file-list="fileList"
            style="width: 270px;"
        >
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
        </el-upload>
      </el-form-item>
      <el-form-item>
        <div style="margin:30px 0 0 20px">
          <a href="https://minio.yanhuotiyu.com/yhoss/webCoachClassFee/Import/课时费等级导入_模板.xlsx">下载_导入模板！</a>
        </div>
      </el-form-item>
      <div style="display: flex; justify-content: center; padding-top: 30px">
        <el-button
            type="primary"
            :loading="hintMessage!=='开始导入'"
            @click="importCourseFee"
        >{{ hintMessage }}
        </el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import selectArea from "../../components/SelectArea";
import {selectPageCoachClassFee, exportCoachClassFee, importClassFee} from "../../api/coach";
import {getListCoachAll} from "../../api/workphone";
import {addOrUpdateCourseFee} from "../../api/coach";
// import {ElNotification} from "element-plus";

export default {
  name: "CoachClassFee",
  components: {
    selectArea
  },
  data() {
    return {
      tableData: [],
      tableLoading: false,
      //新增
      detail: {
        applyDate: "",
        coachId: "",
        classMoney: "",
        oneHourMoney: "",
        oneHalfHourMoney: "",
        twoHourMoney: "",
        coachGrade: "",
        year: "",
        month: "",
        onModify: false,
      },
      //修改传入实体
      detailModify: {},
      //弹框
      detailDialog: false,
      // 查询入参
      query: {
        areaIdList: [],
        pageIndex: 1,
        pageSize: 10,
        pageTotal: 0,
        year: null,
        month: null,
        yearAndMonth: null
      },
      // 可选教练
      coachList: [],
      //必填,规则
      formRules: {
        coachId: [{required: true, message: '请选择教练', trigger: 'change'}],
        applyDate: [{required: true, message: '请选择时间', trigger: 'change'}],
        classMoney: [{required: true, message: '请填写大课课时费', trigger: 'blur'}]
      },//规则
      hintMessage: "开始导入",
      courseFeeImportDialog: false,
      //导入 年月参数
      importFeeYearMonth: "",
      //拆分后
      importFeeYear: null,
      importFeeMonth: null,
      limitFileNum: 1,
      //
      fileList: [],
    }
  },
  methods: {
    //执行导入课时费
    importCourseFee() {
      if (this.fileList.length === 0) {
        this.$message.warning("请上传文件！");
        return;
      }
      this.hintMessage = "请稍等....";
      //excel文件封装成独立的formData
      let form = new FormData();
      form.append("file", this.fileList[0]);
      //日期
      if (this.importFeeYearMonth) {
        let dateList = this.yearMonthDateFormat(this.importFeeYearMonth);
        this.importFeeYear = dateList[0];
        this.importFeeMonth = dateList[1];
      } else {
        this.importFeeYear = null;
        this.importFeeMonth = null;
      }
      //封装年月
      form.append("year", this.importFeeYear);
      form.append("month", this.importFeeMonth);
      //赋值文件
      importClassFee(form).then((value) => {
        console.log(value);
        this.hintMessage = "开始导入";
        this.fileList = [];
        if (value.code === 200) {
          if (value.data.code === 5001) {
            /*ElNotification({
              title: "提示信息",
              dangerouslyUseHTMLString: true,
              message:
                  "<strong>" +
                  "<div>" +
                  "异常行数：" +
                  value.data.thisLine +
                  "</div>" +
                  "<div>" +
                  "异常原因：" +
                  value.data.message +
                  "</div>" +
                  '<div style="color: red;">请核实异常行数以上数据是否已经导入成功！</div>' +
                  "</strong>",
              duration: 0,
              type: "error",
            });*/
          } else {
            this.$message.success("导入成功");
          }
        } else {
          this.$message.warning("导入失败,");
        }
      });

    },
    // 文件状态改变时的钩子
    fileChange(file) {
      let extension = file.name.substring(file.name.lastIndexOf(".") + 1);
      let size = file.size / 1024 / 1024;
      if (extension !== "xlsx") {
        this.fileList = [];
        this.$message.warning("只能上传后缀是.xlsx的文件");
      }
      if (size > 30) {
        this.fileList = [];
        this.$message.warning("文件大小不得超过30M");
      }
      if (extension === "xlsx" && size < 30) {
        this.sendEmailError = [];
        this.fileList.push(file.raw);
      }
    },
    //判断上传的文件个数
    exceedFile(files, fileList) {
      this.$message.warning(
          `只能选择 ${this.limitFileNum} 个文件，当前共选择了 ${
              files.length + fileList.length
          } 个`
      );
    },
    //年月日期格式化
    yearMonthDateFormat(val) {
      const date = new Date(val);
      const y = date.getFullYear();
      let m = date.getMonth() + 1;
      m = m < 10 ? "0" + m : m;
      return [y, m];
    },
    //初始化修改数据
    initModifyData() {
      this.detail.applyDate = this.detailModify.applyDate
      this.detail.coachId = this.detailModify.coachId
      this.detail.classMoney = this.detailModify.classMoney
      this.detail.oneHourMoney = this.detailModify.oneHourMoney
      this.detail.oneHalfHourMoney = this.detailModify.oneHalfHourMoney
      this.detail.twoHourMoney=this.detailModify.twoHourMoney
      this.detail.coachGrade = this.detailModify.coachGrade
      this.detail.year = this.detailModify.year
      this.detail.month = this.detailModify.month

      this.detail.onModify = true;
    },
    //新增/修改 提交
    handleSubmit() {
      this.$refs.formRuleRef.validate(valid => {
        if (valid) {
          console.log(this.detail);
          //拆
          [this.detail.year, this.detail.month] = this.detail.applyDate ? this.detail.applyDate.split('-') : [null, null];
          addOrUpdateCourseFee(this.detail).then(res => {
            if (res.code === 200) {
              this.$message.success('操作成功')
              this.selectTableData() // 刷新历史记录
              this.detailDialog=false;
            }
          }).catch(err => {
            this.$message.error(err.message || '分配失败')
          })
        }
      })
    },
    // 获取教练列表
    fetchCoachList(inputCoachName) {
      getListCoachAll({
        keyword: inputCoachName || "", // 关键字参数
      }).then(res => {
        if (res.code === 200) {
          this.coachList = res.data
        } else {
          this.$message.error(`请求校区负责人失败！`);
        }
      })
    },
    //获取区域
    getAreaListId(val) {
      this.query.areaIdList = val;
    },
    //分页点击
    handlePageChange(val) {
      this.query.pageIndex = val;
      this.selectTableData();
    },
    //导出课时费 表格
    exportCoachClassFee() {
      [this.query.year, this.query.month] = this.query.yearAndMonth ? this.query.yearAndMonth.split('-') : [null, null];
      exportCoachClassFee(this.query).then(val => {
        if (val.code == 200) {
          this.$message.success("下载中，请稍后前往右上角下载中心查看！");
        } else {
          this.$message.error(val.message);
        }
      });
    },
    //查询
    selectTableData() {
      this.tableLoading = true;
      //拆
      [this.query.year, this.query.month] = this.query.yearAndMonth ? this.query.yearAndMonth.split('-') : [null, null];
      selectPageCoachClassFee(this.query).then(val => {
        if (val.code == 200) {
          this.tableLoading = false;
          this.tableData = val.data.records;
          this.query.pageTotal = val.data.total;
        } else {
          this.$message.error("获取表格数据失败");
        }
      })
    }
  },
  mounted() {
    //加载可分配的教练
    this.fetchCoachList("");
  },
  created() {
    //加载表格
    this.selectTableData();
  }
}
</script>

<style scoped>

</style>
